var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.orderDialog
        ? [
            _c("order-modal", {
              attrs: { order: _vm.newOrder },
              on: {
                closeDialog: function($event) {
                  return _vm.closeDialog("orderDialog")
                }
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.purchaseOrderDialog
        ? [
            _c("order-modal", {
              attrs: { order: _vm.newPurchaseOrder, type: "purchase-order" },
              on: {
                closeDialog: function($event) {
                  return _vm.closeDialog("purchaseOrderDialog")
                }
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1563f3db", { render: render, staticRenderFns: staticRenderFns })
  }
}